export default "{{ item.type === \"expense\" ? \"-\" : \"+\" }}{{ item.amount | number }}\n";